export default __webpack_public_path__ + "static/media/e-wallet.0cccd51b.svg";